/*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

/**
 * A directive which displays the contents of a user group.
 */
angular.module('groupUserList').directive('guacGroupUserList', [function guacGroupUserList() {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            users : '=',
            context : '=',
            userTemplate : '=',
            userGroupTemplate : '='
        },
        templateUrl: 'app/groupUserList/templates/guacGroupUserList.html',
        controller: ['$scope', '$injector', function guacGroupUserListController($scope, $injector) {

            // Required types
            var UserGroupListItem = $injector.get('UserGroupListItem');

            $scope.$watch("users", function setContents(users) {

                if (users) {
                    // Create item hierarchy, including connections only if they will be visible
                    var rootList = UserGroupListItem.buildUserTree(users);

                    $scope.rootUserGroupList = rootList;

                }
                else
                    $scope.rootUserGroupList = "none";

            });

            $scope.isVisibleUser = function isVisibleUser(item) {
                return item.isUser;
            };

            $scope.isVisibleUserGroup = function isVisibleUserGroup(item) {
                return item.isUserGroup;
            };

            $scope.toggleExpanded = function toggleExpanded(groupUserListItem) {
                groupUserListItem.isExpanded = !groupUserListItem.isExpanded;
            };
        }]
    };
}]);
